(function () {
  'use strict';

  var STORAGE_KEY = 'prewornWardrobeV1';
  var GUEST_DRAFTS_KEY = 'prewornWardrobeDraftsV1';
  var ACTIVE_KEY = 'prewornWardrobeActiveV1';
  var SELECTED_KEY = 'prewornWardrobeSelectedV1';
  var OPTIONS_CACHE_PREFIX = 'preworn:wardrobe-options:v2:';
  var OPTIONS_CACHE_INDEX_KEY = OPTIONS_CACHE_PREFIX + 'index';
  var OPTIONS_CACHE_FRESH_MS = 24 * 60 * 60 * 1000;
  var OPTIONS_CACHE_STALE_MS = 30 * 24 * 60 * 60 * 1000;
  var OPTIONS_CACHE_MAX_ENTRIES = 12;
  var config = window.PREWORN_WARDROBE_CONFIG || {};
  var root;
  var body;
  var status;
  var step = 0;
  var wardrobes = [];
  var pendingGuest = [];
  var optionsCache = {};
  var optionsRequests = {};
  var optionsVerified = {};
  var previousFocus = null;
  var loginPromptEmitted = false;
  var readyResolve = null;
  var readyPromise = new Promise(function (resolve) { readyResolve = resolve; });
  var readyResolved = false;
  var readyError = false;
  var brandDirectory = null;
  var brandDirectoryRequest = null;
  var WARDROBE_COLOURS = [
    'Black', 'White', 'Blue', 'Red', 'Green', 'Grey', 'Pink', 'Brown',
    'Beige', 'Purple', 'Yellow', 'Orange', 'Gold', 'Silver', 'Multicoloured'
  ];
  var WARDROBE_COLOUR_HEXES = {
    Black: '#171717', White: '#f6f4ef', Blue: '#3568a8', Red: '#c43b43',
    Green: '#4f7c54', Grey: '#85888d', Pink: '#d98fa9', Brown: '#79513b',
    Beige: '#d5c3a4', Purple: '#76558e', Yellow: '#e6c84e', Orange: '#d9793c',
    Gold: '#b9923e', Silver: '#b8bdc3', Multicoloured: '#8b6fac'
  };
  var AUDIENCE_ORDER = ['man', 'woman', 'boy', 'girl', 'baby'];

  function blank() {
    return { version: 4, id: null, name: 'My Wardrobe', audience: 'woman', sizes: { top: [], bottom: [], dress: [], shoe: [] }, categories: [], colours: {}, customColours: {}, categoryPreferences: {}, isDefault: true };
  }

  function sizeAllowedForAudience(audience, value) {
    value = String(value || '').replace(/_/g, ' ').replace(/\s+/g, ' ').trim();
    if (!value) return false;
    var standard = /^(?:xxs|xs|s|m|l|xl|xxl|xxxl|[2-9]xl|one size)$/i.test(value);
    if (audience === 'woman') {
      if (/\byears?\b/i.test(value)) return false;
      if (standard) return true;
      if (/\d/.test(value)) return /^uk\s*[0-9]/i.test(value);
      return true;
    }
    if (audience === 'man') {
      if (/^uk\s*/i.test(value) || /\byears?\b/i.test(value)) return false;
      if (standard) return true;
      if (/\d/.test(value) && !/\binch(?:es)?\b/i.test(value)) return false;
      return true;
    }
    if ((audience === 'girl' || audience === 'boy') &&
        (/^uk\s*/i.test(value) || /\bmonths?\b/i.test(value))) return false;
    return true;
  }

  function canonicalColour(value) {
    value = String(value || '').trim().toLowerCase();
    for (var i = 0; i < WARDROBE_COLOURS.length; i++) {
      if (WARDROBE_COLOURS[i].toLowerCase() === value) return WARDROBE_COLOURS[i];
    }
    return '';
  }

  function normaliseColourHex(value) {
    value = String(value || '').trim().toLowerCase();
    if (/^#[0-9a-f]{3}$/.test(value)) {
      value = '#' + value.slice(1).split('').map(function (character) { return character + character; }).join('');
    }
    return /^#[0-9a-f]{6}$/.test(value) ? value : '';
  }

  function colourHexRgb(value) {
    value = normaliseColourHex(value);
    return value ? [
      parseInt(value.slice(1, 3), 16),
      parseInt(value.slice(3, 5), 16),
      parseInt(value.slice(5, 7), 16)
    ] : null;
  }

  function nearestColourFamily(value) {
    var rgb = colourHexRgb(value);
    if (!rgb) return '';
    var closest = 'Multicoloured';
    var closestDistance = Infinity;
    Object.keys(WARDROBE_COLOUR_HEXES).forEach(function (family) {
      if (family === 'Multicoloured') return;
      var candidate = colourHexRgb(WARDROBE_COLOUR_HEXES[family]);
      var distance = Math.pow(rgb[0] - candidate[0], 2) +
        Math.pow(rgb[1] - candidate[1], 2) + Math.pow(rgb[2] - candidate[2], 2);
      if (distance < closestDistance) {
        closest = family;
        closestDistance = distance;
      }
    });
    return closest;
  }

  function clean(input) {
    var next = blank();
    if (!input || typeof input !== 'object') return next;
    var sourceVersion = Math.max(1, Number(input.version || 1) || 1);
    if (AUDIENCE_ORDER.indexOf(input.audience) !== -1) next.audience = input.audience;
    if (typeof input.id === 'number' || /^\d+$/.test(String(input.id || ''))) next.id = Number(input.id);
    next.name = String(input.name || 'My Wardrobe').replace(/\s+/g, ' ').trim().slice(0, 100) || 'My Wardrobe';
    ['top', 'bottom', 'dress', 'shoe'].forEach(function (type) {
      var values = input.sizes && Array.isArray(input.sizes[type]) ? input.sizes[type] : [];
      next.sizes[type] = values.map(function (value) { return String(value).trim().slice(0, 80); })
        .filter(function (value, index, list) {
          if (!value || list.indexOf(value) !== index) return false;
          return sizeAllowedForAudience(next.audience, value);
        }).slice(0, 8);
    });
    var categories = Array.isArray(input.categories) ? input.categories : [];
    next.categories = categories.map(function (value) { return String(value).toLowerCase().replace(/[^a-z0-9_-]/g, '').slice(0, 160); })
      .filter(function (value, index, list) { return value && list.indexOf(value) === index; }).slice(0, 30);
    var suppliedColours = input.colours && typeof input.colours === 'object' ? input.colours : {};
    next.categories.forEach(function (categoryKey) {
      var values = Array.isArray(suppliedColours[categoryKey]) ? suppliedColours[categoryKey] : [];
      var selected = values.map(canonicalColour).filter(function (value, index, list) {
        return value && list.indexOf(value) === index;
      }).slice(0, WARDROBE_COLOURS.length);
      if (selected.length > 0 && selected.length < WARDROBE_COLOURS.length) {
        next.colours[categoryKey] = selected;
      }
    });
    var suppliedCustomColours = input.customColours && typeof input.customColours === 'object'
      ? input.customColours : {};
    next.categories.forEach(function (categoryKey) {
      var values = Array.isArray(suppliedCustomColours[categoryKey])
        ? suppliedCustomColours[categoryKey] : [];
      var selected = [];
      values.forEach(function (entry) {
        var hex = normaliseColourHex(entry && typeof entry === 'object' ? entry.hex : entry);
        var family = canonicalColour(entry && typeof entry === 'object' ? entry.family : '') ||
          nearestColourFamily(hex);
        if (!hex || !family || selected.some(function (item) { return item.hex === hex; })) return;
        selected.push({ hex: hex, family: family });
      });
      if (selected.length) next.customColours[categoryKey] = selected.slice(0, 6);
    });
    var suppliedPreferences = input.categoryPreferences && typeof input.categoryPreferences === 'object'
      ? input.categoryPreferences : {};
    next.categories.forEach(function (categoryKey) {
      var supplied = suppliedPreferences[categoryKey];
      if (!supplied || typeof supplied !== 'object') return;
      var sizeMode = ['default', 'custom', 'all'].indexOf(supplied.sizeMode) !== -1
        ? supplied.sizeMode : 'default';
      var sizes = Array.isArray(supplied.sizes) ? supplied.sizes : [];
      sizes = sizes.map(function (value) { return String(value).replace(/\s+/g, ' ').trim().slice(0, 80); })
        .filter(function (value, index, list) {
          return value && list.indexOf(value) === index && sizeAllowedForAudience(next.audience, value);
        }).slice(0, 16);
      var patterns = Array.isArray(supplied.patterns) ? supplied.patterns : [];
      patterns = patterns.map(function (value) { return String(value).replace(/\s+/g, ' ').trim().slice(0, 100); })
        .filter(function (value, index, list) { return value && list.indexOf(value) === index; }).slice(0, 16);
      var styles = Array.isArray(supplied.styles) ? supplied.styles : [];
      styles = styles.map(function (value) { return String(value).replace(/\s+/g, ' ').trim().slice(0, 100); })
        .filter(function (value, index, list) { return value && list.indexOf(value) === index; }).slice(0, 24);
      var brands = Array.isArray(supplied.brands) ? supplied.brands : [];
      brands = brands.map(function (value) { return String(value).replace(/\s+/g, ' ').trim().slice(0, 100); })
        .filter(function (value, index, list) { return value && list.indexOf(value) === index; }).slice(0, 24);
      if (sizeMode === 'custom' && !sizes.length) sizeMode = 'all';
      // V2 guest drafts could retain collection-specific sizes created by an
      // older contextual picker after the shopper changed their simple Tops,
      // Bottoms or Dresses default.  The invisible override then outranked the
      // size displayed in the basic Wardrobe editor.  Migrate only device
      // wardrobes; account Wardrobes keep their intentional Advanced settings.
      if (!config.loggedIn && sourceVersion < 3 && sizeMode === 'custom') {
        sizeMode = 'default';
        sizes = [];
      }
      next.categoryPreferences[categoryKey] = {
        sizeMode: sizeMode,
        sizes: sizeMode === 'custom' ? sizes : [],
        styles: styles,
        patterns: patterns,
        brands: brands
      };
    });
    next.isDefault = input.isDefault !== false;
    return next;
  }

  function resolveReady() {
    if (readyResolved || !readyResolve) return;
    readyResolved = true;
    readyResolve({
      wardrobe: clean(current),
      wardrobes: wardrobes.map(clean),
      error: readyError
    });
  }

  function audienceLabel(audience) {
    return { man: 'Men', woman: 'Women', boy: 'Boys', girl: 'Girls', baby: 'Baby' }[audience] || 'Wardrobe';
  }

  function guestWardrobeDepartmentLabel(audience) {
    return {
      man: "Men's",
      woman: "Women's",
      boy: 'Boys',
      girl: 'Girls',
      baby: 'Baby'
    }[audience] || 'My Wardrobe';
  }

  function guestWardrobeName(audience) {
    var label = guestWardrobeDepartmentLabel(audience);
    return label === 'My Wardrobe' ? label : label + ' Wardrobe';
  }

  function readLegacyGuest() {
    try { return clean(JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null')); }
    catch (error) { return blank(); }
  }

  function readGuestDrafts() {
    var drafts = {};
    try {
      var saved = JSON.parse(window.localStorage.getItem(GUEST_DRAFTS_KEY) || 'null');
      var supplied = saved && saved.drafts && typeof saved.drafts === 'object'
        ? saved.drafts : saved;
      if (supplied && typeof supplied === 'object') {
        AUDIENCE_ORDER.forEach(function (audience) {
          var draft = clean(supplied[audience]);
          if (hasPreferences(draft) && draft.audience === audience) drafts[audience] = draft;
        });
      }
    } catch (error) {}
    var legacy = readLegacyGuest();
    if (hasPreferences(legacy) && !drafts[legacy.audience]) drafts[legacy.audience] = legacy;
    return drafts;
  }

  function guestDraftList() {
    return AUDIENCE_ORDER.map(function (audience) {
      return guestDrafts[audience] ? clean(guestDrafts[audience]) : null;
    }).filter(Boolean);
  }

  function persistGuestDrafts() {
    try {
      window.localStorage.setItem(GUEST_DRAFTS_KEY, JSON.stringify({
        version: 1,
        drafts: guestDrafts
      }));
      return true;
    } catch (error) {
      return false;
    }
  }

  function readGuest() {
    var legacy = readLegacyGuest();
    if (hasPreferences(legacy) && guestDrafts[legacy.audience]) {
      return clean(guestDrafts[legacy.audience]);
    }
    var drafts = guestDraftList();
    return drafts.length ? drafts[0] : blank();
  }

  var guestDrafts = readGuestDrafts();
  var current = readGuest();
  var active = false;
  try { active = window.localStorage.getItem(ACTIVE_KEY) === '1'; } catch (error) {}

  function hasPreferences(wardrobe) {
    return !!(wardrobe && (wardrobe.categories.length || wardrobe.sizes.top.length || wardrobe.sizes.bottom.length || wardrobe.sizes.dress.length));
  }

  function emit(name, detail) {
    var payload = detail || {};
    window.dispatchEvent(new CustomEvent('preworn:' + name, { detail: payload }));
    window.dispatchEvent(new CustomEvent('preworn:analytics', { detail: { event: name, properties: payload } }));
  }

  function announce(message, isError) {
    if (!status) return;
    status.textContent = message || '';
    status.classList.toggle('is-error', !!isError);
  }

  function saveGuest(wardrobe) {
    try {
      var saved = clean(wardrobe);
      guestDrafts[saved.audience] = saved;
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
      return persistGuestDrafts();
    } catch (error) {
      return false;
    }
  }

  function clearGuestStorage() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
      window.localStorage.removeItem(GUEST_DRAFTS_KEY);
    } catch (error) {}
    guestDrafts = {};
  }

  function clearGuestWardrobe() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
      window.localStorage.removeItem(GUEST_DRAFTS_KEY);
      window.localStorage.removeItem(ACTIVE_KEY);
      window.localStorage.removeItem(SELECTED_KEY);
      window.localStorage.removeItem('prewornWardrobeLastVisitV1');
    } catch (error) {}
    current = blank();
    active = false;
    guestDrafts = {};
    pendingGuest = [];
    step = 0;
    emit('wardrobe_deleted', { persistent: false });
    if (root && !root.hidden) {
      renderAccount();
      render();
    }
    notify();
    return clean(current);
  }

  function notify() {
    var isApplied = active && hasPreferences(current);
    var isReady = hasPreferences(current);
    document.querySelectorAll('[data-pw-wardrobe-count]').forEach(function (node) {
      node.textContent = isApplied ? '✓' : '';
    });
    document.querySelectorAll('[data-pw-wardrobe-open]').forEach(function (node) {
      node.classList.toggle('is-active', isApplied);
    });
    document.querySelectorAll('[data-pw-wardrobe-toggle]').forEach(function (node) {
      node.classList.toggle('is-active', isApplied);
      node.setAttribute('aria-pressed', isApplied ? 'true' : 'false');
      node.setAttribute('aria-label', isReady
        ? (isApplied ? 'Turn My Wardrobe off' : 'Turn My Wardrobe on')
        : 'Set up My Wardrobe');
      node.setAttribute('title', isReady
        ? (isApplied ? 'Turn My Wardrobe off' : 'Turn My Wardrobe on')
        : 'Set up My Wardrobe');
    });
    document.querySelectorAll('.pw-header-wardrobe-label').forEach(function (node) {
      node.textContent = isReady ? 'My Wardrobe' : 'Wardrobe';
    });
    document.querySelectorAll('[data-pw-mobile-wardrobe-label]').forEach(function (node) {
      node.textContent = isApplied ? 'My Wardrobe ✓' : 'My Wardrobe';
    });
    document.querySelectorAll('[data-pw-wardrobe-home]').forEach(function (node) {
      node.setAttribute('aria-label', isReady ? 'Open My Wardrobe page' : 'Set up My Wardrobe');
    });
    renderHeaderWardrobeControls();
    window.dispatchEvent(new CustomEvent('preworn:wardrobe-change', { detail: { wardrobe: clean(current), active: isApplied } }));
  }

  function setActive(value) {
    active = !!value && hasPreferences(current);
    try { window.localStorage.setItem(ACTIVE_KEY, active ? '1' : '0'); } catch (error) {}
    emit(active ? 'wardrobe_activated' : 'wardrobe_deactivated', { audience: current.audience, categoryCount: current.categories.length });
    notify();
    return active;
  }

  function rememberSelectedWardrobe(id) {
    try {
      if (id) window.localStorage.setItem(SELECTED_KEY, String(id));
      else window.localStorage.removeItem(SELECTED_KEY);
    } catch (error) {}
  }

  function selectWardrobe(wardrobeId, activate) {
    wardrobeId = Number(wardrobeId);
    var selected = null;
    wardrobes.some(function (wardrobe) {
      if (wardrobe.id === wardrobeId) {
        selected = clean(wardrobe);
        return true;
      }
      return false;
    });
    if (!selected) return null;
    current = selected;
    rememberSelectedWardrobe(current.id);
    step = 0;
    if (root && !root.hidden) {
      renderAccount();
      render();
    }
    emit('wardrobe_selected', {
      wardrobeId: current.id,
      audience: current.audience,
      categoryCount: current.categories.length,
      active: activate === true ? hasPreferences(current) : active
    });
    // A wardrobe choice is also an explicit request to use that wardrobe.
    // Go through the canonical activation path so persistence, analytics and
    // every wardrobe-dependent surface receive the same state transition as
    // the header power control.
    if (activate === true) setActive(true);
    else notify();
    return clean(current);
  }

  function selectGuestWardrobe(audience, activate) {
    audience = String(audience || '').toLowerCase();
    if (config.loggedIn || AUDIENCE_ORDER.indexOf(audience) === -1 ||
        !guestDrafts[audience] || !hasPreferences(guestDrafts[audience])) return null;
    current = clean(guestDrafts[audience]);
    saveGuest(current);
    rememberSelectedWardrobe(null);
    step = 0;
    if (root && !root.hidden) {
      renderAccount();
      render();
    }
    emit('wardrobe_selected', {
      wardrobeId: null,
      audience: current.audience,
      categoryCount: current.categories.length,
      active: active,
      persistent: false
    });
    if (activate === true) setActive(true);
    else notify();
    return clean(current);
  }

  function wardrobeForAudience(audience) {
    audience = String(audience || '').toLowerCase();
    if (AUDIENCE_ORDER.indexOf(audience) === -1) return clean(current);
    if (current.audience === audience && hasPreferences(current)) return clean(current);
    if (config.loggedIn) {
      for (var index = 0; index < wardrobes.length; index++) {
        if (wardrobes[index].audience === audience) return clean(wardrobes[index]);
      }
    } else if (guestDrafts[audience]) {
      return clean(guestDrafts[audience]);
    }
    var next = blank();
    next.audience = audience;
    next.isDefault = config.loggedIn ? wardrobes.length === 0 : guestDraftList().length === 0;
    return next;
  }

  function createWardrobe() {
    current = blank();
    current.isDefault = wardrobes.length === 0;
    step = 0;
    open();
    return clean(current);
  }

  function scopeParams(wardrobe) {
    wardrobe = clean(wardrobe || current);
    if (!hasPreferences(wardrobe)) return {};
    var params = { wardrobe_audience: wardrobe.audience, wardrobe_categories: wardrobe.categories.join(',') };
    ['top', 'bottom', 'dress', 'shoe'].forEach(function (type) {
      if (wardrobe.sizes[type].length) params['wardrobe_size_' + type] = wardrobe.sizes[type].join(',');
    });
    var colourParts = [];
    wardrobe.categories.forEach(function (categoryKey) {
      var selected = wardrobe.colours && Array.isArray(wardrobe.colours[categoryKey])
        ? wardrobe.colours[categoryKey].slice() : [];
      var custom = wardrobe.customColours && Array.isArray(wardrobe.customColours[categoryKey])
        ? wardrobe.customColours[categoryKey] : [];
      custom.forEach(function (entry) {
        if (entry.family && selected.indexOf(entry.family) === -1) selected.push(entry.family);
      });
      if (selected.length) colourParts.push(categoryKey + ':' + selected.join('|'));
    });
    if (colourParts.length) params.wardrobe_colours = colourParts.join(';');
    var categorySizes = [];
    var styles = [];
    var patterns = [];
    var brands = [];
    var sharedBrands = null;
    var brandsAreShared = wardrobe.categories.length > 0;
    wardrobe.categories.forEach(function (categoryKey) {
      var preference = wardrobe.categoryPreferences && wardrobe.categoryPreferences[categoryKey];
      if (!preference) {
        brandsAreShared = false;
        return;
      }
      if (preference.sizeMode === 'all') {
        categorySizes.push(categoryKey + ':@all');
      } else if (preference.sizeMode === 'custom' && preference.sizes.length) {
        categorySizes.push(categoryKey + ':' + preference.sizes.map(encodeURIComponent).join('|'));
      }
      if (preference.styles.length) {
        styles.push(categoryKey + ':' + preference.styles.map(encodeURIComponent).join('|'));
      }
      if (preference.patterns.length) {
        patterns.push(categoryKey + ':' + preference.patterns.map(encodeURIComponent).join('|'));
      }
      if (preference.brands.length) {
        brands.push(categoryKey + ':' + preference.brands.map(encodeURIComponent).join('|'));
      }
      var categoryBrands = preference.brands.slice().sort();
      if (!categoryBrands.length) {
        brandsAreShared = false;
      } else if (sharedBrands === null) {
        sharedBrands = categoryBrands;
      } else if (sharedBrands.length !== categoryBrands.length ||
          sharedBrands.some(function (brand, index) {
            return brand !== categoryBrands[index];
          })) {
        brandsAreShared = false;
      }
    });
    if (categorySizes.length) params.wardrobe_category_sizes = categorySizes.join(';');
    if (styles.length) params.wardrobe_styles = styles.join(';');
    if (patterns.length) params.wardrobe_patterns = patterns.join(';');
    // The guided funnel applies one favourite-brand choice to every selected
    // category. Send that common list once so the catalogue can rank directly
    // by vendor instead of building one collection-membership subquery per
    // category. Retain the category map for older/different saved preferences.
    if (brandsAreShared && sharedBrands && sharedBrands.length) {
      params.wardrobe_favourite_brands = sharedBrands.map(encodeURIComponent).join('|');
    } else if (brands.length) {
      params.wardrobe_brands = brands.join(';');
    }
    return params;
  }

  function filterParams(wardrobe) {
    if (!active) return {};
    return scopeParams(wardrobe);
  }

  function api(path, method, payload) {
    var url = String(config.apiUrl || '/apps/preworn/wardrobes').replace(/\/$/, '') + (path || '');
    return fetch(url, {
      method: method || 'GET',
      credentials: 'same-origin',
      headers: payload ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      body: payload ? JSON.stringify(payload) : undefined
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok) throw new Error(data.error || ('HTTP ' + response.status));
        return data;
      });
    });
  }

  function taxonomyFor(audience, payload) {
    var all = payload && Array.isArray(payload.taxonomy) ? payload.taxonomy : [];
    for (var i = 0; i < all.length; i++) if (all[i].key === audience) return all[i];
    return { key: audience, label: audience, categories: [] };
  }

  function categoryLabelMap(payload) {
    var labels = {};
    var collections = payload && Array.isArray(payload.collections) ? payload.collections : [];
    collections.forEach(function (collection) {
      var key = String(collection && collection.key || '').trim();
      var label = String(collection && collection.label || '').replace(/\s+/g, ' ').trim();
      if (key && label) labels[key] = label;
    });
    return labels;
  }

  function categoryOptions(payload) {
    var collections = payload && Array.isArray(payload.collections) ? payload.collections : [];
    return collections.map(function (collection) {
      return {
        key: String(collection && collection.key || '').trim(),
        label: String(collection && collection.label || '').replace(/\s+/g, ' ').trim(),
        sizeType: String(collection && collection.sizeType || '').toLowerCase(),
        count: Math.max(0, Number(collection && collection.count) || 0),
        sampleImage: String(collection && collection.sampleImage || '').trim()
      };
    }).filter(function (collection) {
      return !!collection.key;
    });
  }

  function colourOptions(payload) {
    var colours = payload && Array.isArray(payload.colours) ? payload.colours : [];
    var result = [];
    colours.forEach(function (colour) {
      var value = canonicalColour(colour && (colour.key || colour.value || colour.label));
      if (!value || result.some(function (entry) { return entry.value === value; })) return;
      result.push({
        value: value,
        label: String(colour && colour.label || value).replace(/\s+/g, ' ').trim() || value
      });
    });
    if (!result.length) {
      result = WARDROBE_COLOURS.map(function (value) { return { value: value, label: value }; });
    }
    return result;
  }

  function categorySizeOptions(payload, audience, categoryKey) {
    var collections = payload && Array.isArray(payload.collections) ? payload.collections : [];
    var collection = null;
    collections.some(function (item) {
      if (String(item && item.key || '') !== String(categoryKey || '')) return false;
      collection = item;
      return true;
    });
    var sizeType = String(collection && collection.sizeType || '');
    if (['top', 'bottom', 'dress', 'shoe'].indexOf(sizeType) === -1) return [];
    var options = payload && payload.sizes && Array.isArray(payload.sizes[sizeType])
      ? payload.sizes[sizeType] : [];
    var values = [];
    options.forEach(function (option) {
      var value = String(option && typeof option === 'object' ? option.value : option || '')
        .replace(/_/g, ' ').replace(/\s+/g, ' ').trim();
      if (!sizeAllowedForAudience(audience, value) || values.indexOf(value) !== -1) return;
      values.push(value);
    });
    return values;
  }

  function optionsRequest(audience, selectedSizes) {
    var sizeParts = [];
    ['top', 'bottom', 'dress', 'shoe'].forEach(function (type) {
      var values = selectedSizes && Array.isArray(selectedSizes[type])
        ? selectedSizes[type].slice().sort() : [];
      sizeParts.push(type + '=' + values.join(','));
    });
    return {
      key: audience + '|' + sizeParts.join('|'),
      audience: audience,
      selectedSizes: selectedSizes || {}
    };
  }

  function validOptionsPayload(payload) {
    return !!(payload && typeof payload === 'object' &&
      payload.sizes && typeof payload.sizes === 'object' &&
      Array.isArray(payload.collections) && Array.isArray(payload.colours));
  }

  function optionsStorageKey(cacheKey) {
    return OPTIONS_CACHE_PREFIX + encodeURIComponent(cacheKey);
  }

  function readOptionsCache(cacheKey) {
    var cached = optionsCache[cacheKey];
    try {
      if (!cached && window.localStorage) {
        var raw = window.localStorage.getItem(optionsStorageKey(cacheKey));
        if (raw) cached = JSON.parse(raw);
      }
      var savedAt = Math.max(0, Number(cached && cached.savedAt) || 0);
      var age = Date.now() - savedAt;
      if (!cached || !validOptionsPayload(cached.payload) || age < 0 || age > OPTIONS_CACHE_STALE_MS) {
        delete optionsCache[cacheKey];
        if (window.localStorage) window.localStorage.removeItem(optionsStorageKey(cacheKey));
        return null;
      }
      optionsCache[cacheKey] = cached;
      return { payload: cached.payload, fresh: age <= OPTIONS_CACHE_FRESH_MS };
    } catch (error) {
      return null;
    }
  }

  function writeOptionsCache(cacheKey, payload) {
    if (!validOptionsPayload(payload)) return payload;
    var savedAt = Date.now();
    var cached = { savedAt: savedAt, payload: payload };
    optionsCache[cacheKey] = cached;
    try {
      if (!window.localStorage) return payload;
      window.localStorage.setItem(optionsStorageKey(cacheKey), JSON.stringify(cached));
      var index = JSON.parse(window.localStorage.getItem(OPTIONS_CACHE_INDEX_KEY) || '[]');
      if (!Array.isArray(index)) index = [];
      index = index.filter(function (entry) {
        return entry && entry.key !== cacheKey && savedAt - Number(entry.savedAt || 0) <= OPTIONS_CACHE_STALE_MS;
      });
      index.push({ key: cacheKey, savedAt: savedAt });
      index.sort(function (left, right) { return Number(right.savedAt || 0) - Number(left.savedAt || 0); });
      while (index.length > OPTIONS_CACHE_MAX_ENTRIES) {
        var expired = index.pop();
        window.localStorage.removeItem(optionsStorageKey(expired.key));
        delete optionsCache[expired.key];
      }
      window.localStorage.setItem(OPTIONS_CACHE_INDEX_KEY, JSON.stringify(index));
    } catch (error) {}
    return payload;
  }

  function fetchOptions(request, bypassCache) {
    var pendingKey = request.key + (bypassCache ? '|verify' : '|standard');
    if (optionsRequests[pendingKey]) return optionsRequests[pendingKey];
    var url = new URL(config.catalogApiUrl, window.location.href);
    url.searchParams.set('action', 'wardrobe_options');
    url.searchParams.set('audience', request.audience);
    if (bypassCache) url.searchParams.set('_pw_curation', String(Date.now()));
    ['top', 'bottom', 'dress', 'shoe'].forEach(function (type) {
      var values = request.selectedSizes && Array.isArray(request.selectedSizes[type])
        ? request.selectedSizes[type] : [];
      if (values.length) url.searchParams.set('wardrobe_size_' + type, values.join(','));
    });
    var pending = fetch(url.toString(), {
      headers: { Accept: 'application/json' },
      mode: 'cors',
      cache: bypassCache ? 'no-store' : 'default'
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not load wardrobe options');
      return response.json();
    }).then(function (payload) {
      return writeOptionsCache(request.key, payload);
    });
    optionsRequests[pendingKey] = pending;
    return pending.then(function (payload) {
      delete optionsRequests[pendingKey];
      return payload;
    }, function (error) {
      delete optionsRequests[pendingKey];
      throw error;
    });
  }

  function loadOptions(audience, selectedSizes, verifyCurrent) {
    var request = optionsRequest(audience, selectedSizes);
    var cached = readOptionsCache(request.key);
    // Collection visibility is merchant-controlled. A persisted cache keeps
    // the builder fast, but the collection step must verify it once per page
    // session so a newly disabled handle disappears immediately.
    if (verifyCurrent && !optionsVerified[request.key]) {
      return fetchOptions(request, true).then(function (payload) {
        optionsVerified[request.key] = true;
        return payload;
      }).catch(function (error) {
        if (cached) return cached.payload;
        throw error;
      });
    }
    if (cached) {
      if (!cached.fresh) fetchOptions(request).catch(function () {});
      return Promise.resolve(cached.payload);
    }
    return fetchOptions(request);
  }

  function selectedClass(selected) { return selected ? ' is-selected' : ''; }
  function renderSteps() {
    var steps = root.querySelector('[data-pw-wardrobe-steps]');
    steps.innerHTML = [0, 1, 2, 3, 4, 5].map(function (index) {
      return '<span class="pw-wardrobe__step' + (index <= step ? ' is-active' : '') + '"></span>';
    }).join('');
    root.querySelector('[data-pw-wardrobe-back]').hidden = step === 0;
    var nextButton = root.querySelector('[data-pw-wardrobe-next]');
    nextButton.textContent = step === 5
      ? (config.loggedIn ? 'Save & show my edit' :
        (guestDraftList().length > 1 ? 'Save my wardrobes' : 'Save my wardrobe'))
      : 'Continue';
    nextButton.disabled = step === 5 && !String(current.name || '').trim();
  }

  function renderAudience() {
    var labels = { woman: 'Woman', man: 'Man', girl: 'Girl', boy: 'Boy' };
    body.innerHTML = '<h3>Who are you shopping for?</h3><p class="pw-wardrobe__lead">Choose one person for this wardrobe. You can create another wardrobe later.</p>' +
      '<div class="pw-wardrobe__choices">' + Object.keys(labels).map(function (key) {
        return '<button type="button" class="pw-wardrobe__choice' + selectedClass(current.audience === key) + '" data-audience="' + key + '">' + labels[key] + '</button>';
      }).join('') + '</div>';
    body.querySelectorAll('[data-audience]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (current.audience !== this.getAttribute('data-audience')) {
          current = wardrobeForAudience(this.getAttribute('data-audience'));
        }
        emit('wardrobe_audience_changed', { audience: current.audience });
        render();
      });
    });
    // Start the slowest builder request while the shopper is still on the
    // audience step. A persisted cache means this normally resolves locally.
    loadOptions(current.audience).catch(function () {});
  }

  function renderSizes() {
    body.innerHTML = '<h3>What size fits you?</h3><p class="pw-wardrobe__lead">Pick every size that works for the clothing you chose. You can skip a group.</p><p>Loading live sizes…</p>';
    loadOptions(current.audience).then(function (payload) {
      if (step !== 2) return;
      var html = '<h3>What size fits you?</h3><p class="pw-wardrobe__lead">Pick every size that works for the clothing you chose. You can skip a group.</p>';
      var names = { top: 'Tops & outerwear', bottom: 'Bottoms', dress: 'Dresses & one-pieces', shoe: 'Footwear' };
      var relevantTypes = {};
      (Array.isArray(payload.collections) ? payload.collections : []).forEach(function (collection) {
        if (current.categories.indexOf(String(collection && collection.key || '')) === -1) return;
        var sizeType = String(collection && collection.sizeType || '').toLowerCase();
        if (names[sizeType]) relevantTypes[sizeType] = true;
      });
      var hasRelevantTypes = Object.keys(relevantTypes).length > 0;
      var renderedGroups = 0;
      Object.keys(names).forEach(function (type) {
        if (hasRelevantTypes && !relevantTypes[type]) {
          current.sizes[type] = [];
          return;
        }
        var values = payload.sizes && Array.isArray(payload.sizes[type]) ? payload.sizes[type] : [];
        values = values.filter(function (option) {
          return sizeAllowedForAudience(current.audience, option && option.value);
        });
        if (!values.length) return;
        renderedGroups += 1;
        html += '<section class="pw-wardrobe__group"><h4>' + names[type] + '</h4><div class="pw-wardrobe__sizes">' + values.map(function (option) {
          var value = String(option.value || '');
          return '<button type="button" class="pw-wardrobe__size' + selectedClass(current.sizes[type].indexOf(value) !== -1) + '" data-size-type="' + type + '" data-size="' + escapeHtml(value) + '">' + escapeHtml(value) + '</button>';
        }).join('') + '</div></section>';
      });
      if (!renderedGroups) {
        html += '<div class="pw-wardrobe__empty-step"><strong>No size needed</strong><span>The clothing you chose does not need a size preference. Continue when you’re ready.</span></div>';
      }
      body.innerHTML = html;
      body.querySelectorAll('[data-size]').forEach(function (button) {
        button.addEventListener('click', function () {
          var type = this.getAttribute('data-size-type');
          var value = this.getAttribute('data-size');
          var index = current.sizes[type].indexOf(value);
          if (index === -1 && current.sizes[type].length < 8) current.sizes[type].push(value);
          else if (index !== -1) current.sizes[type].splice(index, 1);
          emit('wardrobe_size_changed', { audience: current.audience, sizeType: type, selectedCount: current.sizes[type].length });
          renderSizes();
        });
      });
    }).catch(function () {
      body.innerHTML = '<h3>Sizes are temporarily unavailable</h3><p class="pw-wardrobe__lead">Continue without sizes and your edit will still use the categories you choose.</p>';
      announce('We could not load live size options.', true);
    });
  }

  function renderCategories(filterValue) {
    filterValue = String(filterValue || '');
    body.innerHTML = '<h3>What clothing do you like?</h3><p class="pw-wardrobe__lead">Loading the current category choices…</p>';
    // The size step has already loaded this audience-level payload. Reuse it
    // here so opening the collection picker never waits for an expensive
    // size-filtered product recount.
    loadOptions(current.audience).then(function (payload) {
      if (step !== 1) return;
      var audience = taxonomyFor(current.audience, payload);
      var collections = Array.isArray(payload.collections) ? payload.collections : audience.categories;
      var availableCollectionKeys = collections.map(function (collection) { return collection.key; });
      current.categories = current.categories.filter(function (key) {
        return availableCollectionKeys.indexOf(key) !== -1;
      });
      Object.keys(current.colours || {}).forEach(function (key) {
        if (current.categories.indexOf(key) === -1) delete current.colours[key];
      });
      var audienceLabel = audience.label || current.audience;
      body.innerHTML = '<h3>What clothing do you like?</h3>' +
        '<p class="pw-wardrobe__lead">Choose every category you’d be happy to shop.</p>' +
        '<div class="pw-wardrobe__collection-tools"><label for="PrewornWardrobeCollectionSearch">Find a category</label>' +
          '<input id="PrewornWardrobeCollectionSearch" type="search" value="' + escapeHtml(filterValue) + '" placeholder="Search ' + escapeHtml(audienceLabel.toLowerCase()) + ' clothing…" autocomplete="off">' +
          '<span>' + collections.length + ' categories · ' + current.categories.length + ' selected</span></div>' +
        '<div class="pw-wardrobe__choices pw-wardrobe__collections">' +
        collections.map(function (collection) {
          return '<button type="button" class="pw-wardrobe__choice' + selectedClass(current.categories.indexOf(collection.key) !== -1) + '" aria-pressed="' + (current.categories.indexOf(collection.key) !== -1 ? 'true' : 'false') + '" data-category="' + escapeHtml(collection.key) + '" data-collection-label="' + escapeHtml(String(collection.label || '').toLowerCase()) + '"><span>' + escapeHtml(collection.label) + '</span></button>';
        }).join('') + '</div>';
      var search = body.querySelector('#PrewornWardrobeCollectionSearch');
      function applyCollectionSearch() {
        var query = String(search.value || '').trim().toLowerCase();
        body.querySelectorAll('[data-collection-label]').forEach(function (button) {
          button.hidden = query !== '' && button.getAttribute('data-collection-label').indexOf(query) === -1;
        });
      }
      search.addEventListener('input', applyCollectionSearch);
      applyCollectionSearch();
      body.querySelectorAll('[data-category]').forEach(function (button) {
        button.addEventListener('click', function () {
          var key = this.getAttribute('data-category');
          var index = current.categories.indexOf(key);
          if (index === -1) {
            if (current.categories.length >= 30) {
              announce('You can select up to 30 collections in one wardrobe.', true);
              return;
            }
            current.categories.push(key);
          } else {
            current.categories.splice(index, 1);
            delete current.colours[key];
            delete current.customColours[key];
            delete current.categoryPreferences[key];
          }
          emit('wardrobe_category_changed', { audience: current.audience, selectedCount: current.categories.length });
          renderCategories(search.value);
        });
      });
    }).catch(function () {
      body.innerHTML = '<h3>Collections are temporarily unavailable</h3><p class="pw-wardrobe__lead">Please try again in a moment.</p>';
      announce('We could not load wardrobe collections.', true);
    });
  }

  function renderColours() {
    body.innerHTML = '<h3>What colours do you like?</h3><p class="pw-wardrobe__lead">Loading colour choices…</p>';
    loadOptions(current.audience, current.sizes).then(function (payload) {
      if (step !== 3) return;
      var palette = Array.isArray(payload.colours) && payload.colours.length
        ? payload.colours.filter(function (colour) { return canonicalColour(colour.key) !== ''; })
        : WARDROBE_COLOURS.map(function (colour) { return { key: colour, label: colour }; });
      var collectionLabels = {};
      (Array.isArray(payload.collections) ? payload.collections : []).forEach(function (collection) {
        collectionLabels[collection.key] = collection.label;
      });
      Object.keys(current.colours || {}).forEach(function (key) {
        if (current.categories.indexOf(key) === -1) delete current.colours[key];
      });
      var html = '<h3>What colours do you like?</h3>' +
        '<p class="pw-wardrobe__lead">Choose from the ready-made palette or add an exact custom shade. Leave a category on All colours to see everything.</p>' +
        '<div class="pw-wardrobe__colour-groups">';
      current.categories.forEach(function (categoryKey) {
        var selected = Array.isArray(current.colours[categoryKey]) ? current.colours[categoryKey] : [];
        var custom = Array.isArray(current.customColours[categoryKey]) ? current.customColours[categoryKey] : [];
        var label = collectionLabels[categoryKey] || categoryKey.replace(/[-_]+/g, ' ').replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
        var totalSelected = selected.length + custom.length;
        var pickerValue = custom.length ? custom[custom.length - 1].hex :
          (selected.length && WARDROBE_COLOUR_HEXES[selected[0]] ? WARDROBE_COLOUR_HEXES[selected[0]] : '#5278a7');
        html += '<section class="pw-wardrobe__colour-group" data-colour-group="' + escapeHtml(categoryKey) + '">' +
          '<header><h4>' + escapeHtml(label) + '</h4><small data-colour-summary>' + (totalSelected ? totalSelected + ' selected' : 'All colours') + '</small></header>' +
          '<div class="pw-wardrobe__colours">' +
            '<button type="button" class="pw-wardrobe__colour pw-wardrobe__colour--all' + selectedClass(totalSelected === 0) + '" aria-pressed="' + (totalSelected === 0 ? 'true' : 'false') + '" data-colour-category="' + escapeHtml(categoryKey) + '" data-colour-all><span>All</span><strong>All colours</strong></button>' +
            palette.map(function (colour) {
              var value = canonicalColour(colour.key);
              var isSelected = selected.indexOf(value) !== -1;
              var slug = value.toLowerCase().replace(/[^a-z0-9]+/g, '-');
              return '<button type="button" class="pw-wardrobe__colour' + selectedClass(isSelected) + '" aria-pressed="' + (isSelected ? 'true' : 'false') + '" data-colour-category="' + escapeHtml(categoryKey) + '" data-colour-value="' + escapeHtml(value) + '"><span class="pw-wardrobe__colour-swatch pw-wardrobe__colour-swatch--' + slug + '" aria-hidden="true"></span><strong>' + escapeHtml(colour.label || value) + '</strong></button>';
            }).join('') +
          '</div>' +
          '<div class="pw-wardrobe__custom-colour"><div><strong>Add a custom shade</strong><small>We’ll save the exact shade and match it to the closest catalogue colour family.</small></div>' +
            '<label><input type="color" value="' + escapeHtml(pickerValue) + '" aria-label="Choose a custom colour for ' + escapeHtml(label) + '" data-custom-colour-input="' + escapeHtml(categoryKey) + '"></label>' +
            '<button type="button" data-custom-colour-add="' + escapeHtml(categoryKey) + '">Add shade</button></div>' +
          '<div class="pw-wardrobe__custom-colours"' + (custom.length ? '' : ' hidden') + '>' +
            custom.map(function (entry) {
              return '<button type="button" class="pw-wardrobe__custom-chip" data-custom-colour-remove="' + escapeHtml(categoryKey) + '" data-custom-colour-hex="' + escapeHtml(entry.hex) + '" title="Remove ' + escapeHtml(entry.hex) + '"><i style="--pw-custom-colour:' + escapeHtml(entry.hex) + '"></i><span><strong>' + escapeHtml(entry.hex.toUpperCase()) + '</strong><small>Matched to ' + escapeHtml(entry.family) + '</small></span><b aria-hidden="true">×</b></button>';
            }).join('') +
          '</div></section>';
      });
      body.innerHTML = html + '</div>';

      function refreshColourGroup(categoryKey) {
        var selected = Array.isArray(current.colours[categoryKey]) ? current.colours[categoryKey] : [];
        var custom = Array.isArray(current.customColours[categoryKey]) ? current.customColours[categoryKey] : [];
        body.querySelectorAll('[data-colour-category]').forEach(function (button) {
          if (button.getAttribute('data-colour-category') !== categoryKey) return;
          var isSelected = button.hasAttribute('data-colour-all')
            ? selected.length === 0 && custom.length === 0
            : selected.indexOf(button.getAttribute('data-colour-value')) !== -1;
          button.classList.toggle('is-selected', isSelected);
          button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
        body.querySelectorAll('[data-colour-group]').forEach(function (group) {
          if (group.getAttribute('data-colour-group') !== categoryKey) return;
          var summary = group.querySelector('[data-colour-summary]');
          var totalSelected = selected.length + custom.length;
          if (summary) summary.textContent = totalSelected ? totalSelected + ' selected' : 'All colours';
        });
      }

      body.querySelectorAll('[data-colour-category]').forEach(function (button) {
        button.addEventListener('click', function () {
          var categoryKey = this.getAttribute('data-colour-category');
          if (this.hasAttribute('data-colour-all')) {
            delete current.colours[categoryKey];
            delete current.customColours[categoryKey];
          } else {
            var value = this.getAttribute('data-colour-value');
            var selected = Array.isArray(current.colours[categoryKey])
              ? current.colours[categoryKey].slice() : [];
            var index = selected.indexOf(value);
            if (index === -1) selected.push(value); else selected.splice(index, 1);
            if (selected.length === 0 || selected.length >= palette.length) delete current.colours[categoryKey];
            else current.colours[categoryKey] = selected;
          }
          refreshColourGroup(categoryKey);
          emit('wardrobe_colour_changed', {
            audience: current.audience,
            category: categoryKey,
            selectedCount: current.colours[categoryKey] ? current.colours[categoryKey].length : 0
          });
        });
      });
      body.querySelectorAll('[data-custom-colour-add]').forEach(function (button) {
        button.addEventListener('click', function () {
          var categoryKey = this.getAttribute('data-custom-colour-add');
          var input = body.querySelector('[data-custom-colour-input="' + categoryKey + '"]');
          var hex = normaliseColourHex(input && input.value);
          var family = nearestColourFamily(hex);
          var selected = Array.isArray(current.customColours[categoryKey])
            ? current.customColours[categoryKey].slice() : [];
          if (!hex || !family) return;
          if (selected.some(function (entry) { return entry.hex === hex; })) {
            announce('That custom shade is already selected.', true);
            return;
          }
          if (selected.length >= 6) {
            announce('You can add up to six custom shades to each category.', true);
            return;
          }
          selected.push({ hex: hex, family: family });
          current.customColours[categoryKey] = selected;
          emit('wardrobe_custom_colour_changed', {
            audience: current.audience,
            category: categoryKey,
            family: family,
            selectedCount: selected.length
          });
          renderColours();
        });
      });
      body.querySelectorAll('[data-custom-colour-remove]').forEach(function (button) {
        button.addEventListener('click', function () {
          var categoryKey = this.getAttribute('data-custom-colour-remove');
          var hex = this.getAttribute('data-custom-colour-hex');
          var selected = Array.isArray(current.customColours[categoryKey])
            ? current.customColours[categoryKey].filter(function (entry) { return entry.hex !== hex; }) : [];
          if (selected.length) current.customColours[categoryKey] = selected;
          else delete current.customColours[categoryKey];
          emit('wardrobe_custom_colour_changed', {
            audience: current.audience,
            category: categoryKey,
            selectedCount: selected.length
          });
          renderColours();
        });
      });
    }).catch(function () {
      body.innerHTML = '<h3>Colours are temporarily unavailable</h3><p class="pw-wardrobe__lead">Continue with All colours and no colour restriction will be applied.</p>';
      announce('We could not load wardrobe colours.', true);
    });
  }

  function loadBrandDirectory() {
    if (brandDirectory) return Promise.resolve(brandDirectory);
    if (brandDirectoryRequest) return brandDirectoryRequest;
    var url = new URL(config.catalogApiUrl, window.location.href);
    url.searchParams.set('action', 'brands');
    url.searchParams.set('all', '1');
    brandDirectoryRequest = fetch(url.toString(), {
      mode: 'cors',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not load brands');
      return response.json();
    }).then(function (payload) {
      var entries = Array.isArray(payload && payload.brands) ? payload.brands : [];
      brandDirectory = entries.map(function (entry) {
        return {
          name: String(entry && entry.name || '').replace(/\s+/g, ' ').trim().slice(0, 100),
          count: Math.max(0, Number(entry && entry.count) || 0)
        };
      }).filter(function (entry, index, list) {
        return entry.name && list.findIndex(function (candidate) {
          return candidate.name.toLowerCase() === entry.name.toLowerCase();
        }) === index;
      });
      brandDirectoryRequest = null;
      return brandDirectory;
    }, function (error) {
      brandDirectoryRequest = null;
      throw error;
    });
    return brandDirectoryRequest;
  }

  function preferredBrands() {
    var selected = [];
    current.categories.forEach(function (categoryKey) {
      var preference = current.categoryPreferences && current.categoryPreferences[categoryKey];
      (preference && Array.isArray(preference.brands) ? preference.brands : []).forEach(function (brand) {
        if (selected.indexOf(brand) === -1) selected.push(brand);
      });
    });
    return selected.slice(0, 24);
  }

  function applyPreferredBrands(selected) {
    selected = selected.slice(0, 24);
    current.categories.forEach(function (categoryKey) {
      var preference = current.categoryPreferences[categoryKey] || {
        sizeMode: 'default', sizes: [], styles: [], patterns: [], brands: []
      };
      preference.brands = selected.slice();
      current.categoryPreferences[categoryKey] = preference;
    });
  }

  function renderBrands(filterValue) {
    filterValue = String(filterValue || '');
    body.innerHTML = '<h3>Do you like any particular brands?</h3><p class="pw-wardrobe__lead">Search every available brand. Your favourites appear first, but we’ll still show matching pieces from other brands.</p><p>Loading brands…</p>';
    loadBrandDirectory().then(function (entries) {
      if (step !== 4) return;
      var selected = preferredBrands();
      selected.forEach(function (brand) {
        if (!entries.some(function (entry) { return entry.name === brand; })) {
          entries.push({ name: brand, count: 0 });
        }
      });
      var query = filterValue.trim().toLowerCase();
      var matches = entries.filter(function (entry) {
        return !query || entry.name.toLowerCase().indexOf(query) !== -1;
      }).sort(function (left, right) {
        var leftSelected = selected.indexOf(left.name) !== -1 ? 1 : 0;
        var rightSelected = selected.indexOf(right.name) !== -1 ? 1 : 0;
        if (leftSelected !== rightSelected) return rightSelected - leftSelected;
        if (left.count !== right.count) return right.count - left.count;
        return left.name.localeCompare(right.name);
      });
      var visible = query ? matches.slice(0, 80) : matches.slice(0, 36);
      body.innerHTML = '<h3>Do you like any particular brands?</h3>' +
        '<p class="pw-wardrobe__lead">Search every available brand. Favourites rank first; other matching brands stay visible.</p>' +
        '<div class="pw-wardrobe__brand-tools"><label for="PrewornWardrobeBrandSearch">Search brands</label>' +
          '<input id="PrewornWardrobeBrandSearch" type="search" value="' + escapeHtml(filterValue) + '" placeholder="Try Nike, NEXT or Zara…" autocomplete="off">' +
          '<span>' + selected.length + ' selected · ' + entries.length.toLocaleString('en-GB') + ' available</span></div>' +
        (selected.length ? '<div class="pw-wardrobe__brand-selected" aria-label="Selected brands">' + selected.map(function (brand) {
          return '<button type="button" data-brand-choice="' + escapeHtml(brand) + '" aria-pressed="true"><span>' + escapeHtml(brand) + '</span><b aria-hidden="true">×</b></button>';
        }).join('') + '</div>' : '') +
        '<div class="pw-wardrobe__brands">' + (visible.length ? visible.map(function (entry) {
          var isSelected = selected.indexOf(entry.name) !== -1;
          return '<button type="button" class="pw-wardrobe__brand' + selectedClass(isSelected) + '" data-brand-choice="' + escapeHtml(entry.name) + '" aria-pressed="' + (isSelected ? 'true' : 'false') + '"><span>' + escapeHtml(entry.name) + '</span>' + (entry.count ? '<small>' + entry.count.toLocaleString('en-GB') + '</small>' : '') + '</button>';
        }).join('') : '<p class="pw-wardrobe__brand-empty">No brands match that search.</p>') + '</div>';
      var search = body.querySelector('#PrewornWardrobeBrandSearch');
      search.addEventListener('input', function () {
        var value = this.value;
        renderBrands(value);
        window.requestAnimationFrame(function () {
          var nextSearch = body.querySelector('#PrewornWardrobeBrandSearch');
          if (nextSearch) {
            nextSearch.focus();
            nextSearch.setSelectionRange(value.length, value.length);
          }
        });
      });
      body.querySelectorAll('[data-brand-choice]').forEach(function (button) {
        button.addEventListener('click', function () {
          var brand = this.getAttribute('data-brand-choice');
          var brands = preferredBrands();
          var index = brands.indexOf(brand);
          if (index === -1) {
            if (brands.length >= 24) {
              announce('You can choose up to 24 favourite brands.', true);
              return;
            }
            brands.push(brand);
          } else brands.splice(index, 1);
          applyPreferredBrands(brands);
          emit('wardrobe_brand_changed', {
            audience: current.audience,
            selectedCount: brands.length
          });
          renderBrands(filterValue);
        });
      });
    }).catch(function () {
      if (step !== 4) return;
      body.innerHTML = '<h3>Brands are temporarily unavailable</h3><p class="pw-wardrobe__lead">You can continue without choosing brands and add favourites later in the Advanced editor.</p>';
      announce('We could not load the brand directory.', true);
    });
  }

  function wardrobeCount() {
    var params = scopeParams(current);
    params.wardrobe_audience = current.audience;
    params.wardrobe_categories = current.categories.join(',');
    ['top', 'bottom', 'dress', 'shoe'].forEach(function (type) {
      if (current.sizes[type].length) params['wardrobe_size_' + type] = current.sizes[type].join(',');
    });
    var url = new URL(config.catalogApiUrl, window.location.href);
    url.searchParams.set('action', 'search');
    url.searchParams.set('limit', '1');
    url.searchParams.set('include_facets', '0');
    url.searchParams.set('count_only', '1');
    Object.keys(params).forEach(function (key) { url.searchParams.set(key, params[key]); });
    return fetch(url.toString(), { mode: 'cors', headers: { Accept: 'application/json' } }).then(function (response) { return response.json(); });
  }

  function renderSummary() {
    var drafts = !config.loggedIn ? guestDraftList() : [];
    var namingMultiple = config.loggedIn && drafts.length > 1;
    if (!config.loggedIn) current.name = guestWardrobeName(current.audience);
    var nameCards = namingMultiple
      ? drafts.map(function (draft) {
        var savedName = String(draft.name || '').trim();
        if (savedName === 'My Wardrobe') savedName = '';
        return '<label class="pw-wardrobe__name pw-wardrobe__name--draft">' +
          '<span>' + escapeHtml(audienceLabel(draft.audience)) + ' wardrobe name</span>' +
          '<span class="pw-wardrobe__name-input">' +
            '<input type="text" maxlength="100" autocomplete="off" spellcheck="false" ' +
              'placeholder="For example: ' + escapeHtml(audienceLabel(draft.audience)) + ' essentials" ' +
              'value="' + escapeHtml(savedName) + '" data-pw-draft-name="' + escapeHtml(draft.audience) + '">' +
            '<i data-pw-draft-name-state="' + escapeHtml(draft.audience) + '">' +
              (savedName ? 'READY TO SAVE' : 'NAME REQUIRED') + '</i>' +
          '</span></label>';
      }).join('')
      : '<label class="pw-wardrobe__name"><span>Wardrobe name</span><span class="pw-wardrobe__name-input">' +
        '<input type="text" maxlength="100" autocomplete="off" spellcheck="false" aria-describedby="PrewornWardrobeNameHelp" placeholder="For example: Adam, Workwear or Holiday" value="' + escapeHtml(current.name) + '" data-pw-name>' +
        '<i data-pw-name-state>READY TO SAVE</i></span></label>';
    var identityPanel = config.loggedIn
      ? '<section class="pw-wardrobe__name-card" aria-labelledby="PrewornWardrobeNameTitle">' +
          '<header class="pw-wardrobe__name-head"><span>SAVE THIS EDIT AS</span><h4 id="PrewornWardrobeNameTitle">' +
            (namingMultiple ? 'Name each wardrobe' : 'Name your wardrobe') + '</h4>' +
          '<p id="PrewornWardrobeNameHelp">' + (namingMultiple
            ? 'Your Men, Women, Boys, Girls and Baby preferences stay separate. Give each profile its own name before saving.'
            : 'This is the name you’ll see in your wardrobe switcher and across your personalised edit.') + '</p></header>' +
          nameCards + '</section>'
      : '<section class="pw-wardrobe__name-card pw-wardrobe__name-card--department" ' +
          'aria-labelledby="PrewornWardrobeNameTitle"><header class="pw-wardrobe__name-head">' +
          '<span>SAVED BY DEPARTMENT</span><h4 id="PrewornWardrobeNameTitle">' +
          escapeHtml(guestWardrobeDepartmentLabel(current.audience)) + '</h4>' +
          '<p>This department is named automatically in your wardrobe switcher.</p></header></section>';
    body.innerHTML = '<h3>Your wardrobe is ready</h3><p class="pw-wardrobe__lead">We’re counting the one-off pieces that match right now.</p><div class="pw-wardrobe__summary"><strong data-pw-count>…</strong><span>matching pieces currently available</span></div>' +
      (!config.loggedIn ? '<p class="pw-wardrobe__lead" style="margin-top:18px">Your wardrobe will be saved on this device. <a href="/account/login">Sign in or create a free account</a> and we’ll remember it across devices.</p>' : '') +
      identityPanel;
    if (!config.loggedIn && !loginPromptEmitted) {
      loginPromptEmitted = true;
      emit('wardrobe_login_prompt_shown', { audience: current.audience });
    }
    var nameCard = body.querySelector('.pw-wardrobe__name-card');
    var saveButton = root.querySelector('[data-pw-wardrobe-next]');
    if (!config.loggedIn) {
      if (saveButton) saveButton.disabled = false;
    } else if (namingMultiple) {
      var draftInputs = Array.prototype.slice.call(body.querySelectorAll('[data-pw-draft-name]'));
      function updateDraftNameState() {
        var allNamed = draftInputs.every(function (input) {
          var audience = input.getAttribute('data-pw-draft-name');
          var value = String(input.value || '').replace(/\s+/g, ' ').trim().slice(0, 100);
          var stateNode = body.querySelector('[data-pw-draft-name-state="' + audience + '"]');
          if (stateNode) stateNode.textContent = value ? 'READY TO SAVE' : 'NAME REQUIRED';
          input.closest('.pw-wardrobe__name').classList.toggle('is-name-missing', !value);
          if (value && guestDrafts[audience]) guestDrafts[audience].name = value;
          if (value && current.audience === audience) current.name = value;
          return !!value;
        });
        if (nameCard) nameCard.classList.toggle('is-name-missing', !allNamed);
        if (saveButton) saveButton.disabled = !allNamed;
      }
      draftInputs.forEach(function (input) {
        input.addEventListener('input', updateDraftNameState);
      });
      updateDraftNameState();
    } else {
      var name = body.querySelector('[data-pw-name]');
      var nameState = body.querySelector('[data-pw-name-state]');
    function updateNameState() {
      var isNamed = !!String(name.value || '').trim();
      if (nameState) nameState.textContent = isNamed ? 'READY TO SAVE' : 'NAME REQUIRED';
      if (nameCard) nameCard.classList.toggle('is-name-missing', !isNamed);
      if (saveButton) saveButton.disabled = !isNamed;
    }
    name.addEventListener('input', function () {
      current.name = this.value.slice(0, 100);
      renderEditorTitle();
      updateNameState();
    });
    updateNameState();
    }
    wardrobeCount().then(function (payload) {
      var count = body.querySelector('[data-pw-count]');
      if (count) count.textContent = Math.max(0, Number(payload.totalCount || 0)).toLocaleString('en-GB');
    }).catch(function () {
      var count = body.querySelector('[data-pw-count]');
      if (count) count.textContent = '—';
    });
  }

  function render() {
    announce('');
    renderSteps();
    if (step === 0) renderAudience();
    else if (step === 1) renderCategories();
    else if (step === 2) renderSizes();
    else if (step === 3) renderColours();
    else if (step === 4) renderBrands();
    else renderSummary();
  }

  function saveCurrent(options) {
    options = options || {};
    if (!config.loggedIn) current.name = guestWardrobeName(current.audience);
    current = clean(current);
    var wasNew = !current.id && (config.loggedIn ||
      !hasPreferences(guestDrafts[current.audience]));
    var request;
    if (config.loggedIn) {
      request = current.id ? api('/' + current.id, 'PUT', current) : api('', 'POST', current);
    } else {
      request = saveGuest(current)
        ? Promise.resolve({ wardrobe: current })
        : Promise.reject(new Error('Your browser could not remember this preference. Check site storage and try again.'));
    }
    return request.then(function (payload) {
      if (payload.wardrobe) current = clean(payload.wardrobe);
      if (config.loggedIn) {
        rememberSelectedWardrobe(current.id);
        if (current.isDefault) {
          wardrobes = wardrobes.map(function (item) {
            var normalised = clean(item);
            if (normalised.id !== current.id) normalised.isDefault = false;
            return normalised;
          });
        }
        var found = false;
        wardrobes = wardrobes.map(function (item) {
          if (item.id === current.id) { found = true; return current; }
          return item;
        });
        if (!found) wardrobes.unshift(current);
        renderAccount();
      }
      // Contextual preference prompts should be able to remember one useful
      // answer without turning the whole Wardrobe filter on. Activating a
      // category-only profile globally could hide unrelated collections.
      if (options.activate === false) notify();
      else setActive(true);
      if (wasNew) emit('wardrobe_created', { audience: current.audience, categoryCount: current.categories.length, persistent: !!config.loggedIn });
      emit('wardrobe_saved', { audience: current.audience, categoryCount: current.categories.length, persistent: !!config.loggedIn });
      return clean(current);
    });
  }

  function setCategorySizes(categoryKey, sizeValues, sizeType, audience, options) {
    options = options || {};
    categoryKey = String(categoryKey || '').toLowerCase()
      .replace(/[^a-z0-9_-]/g, '').slice(0, 160);
    sizeValues = (Array.isArray(sizeValues) ? sizeValues : [sizeValues])
      .map(function (value) {
        return String(value || '').replace(/\s+/g, ' ').trim().slice(0, 80);
      }).filter(function (value, index, values) {
        return value && values.indexOf(value) === index;
      }).slice(0, 16);
    sizeType = String(sizeType || '').toLowerCase();
    audience = String(audience || '').toLowerCase();

    if (!categoryKey || !sizeValues.length) {
      return Promise.reject(new Error('A collection and at least one size are required.'));
    }
    if (['top', 'bottom', 'dress', 'shoe'].indexOf(sizeType) === -1) {
      return Promise.reject(new Error('This collection does not have a supported size type.'));
    }
    if (AUDIENCE_ORDER.indexOf(audience) === -1) {
      return Promise.reject(new Error('This collection does not have a supported audience.'));
    }
    if (!sizeValues.every(function (value) {
      return sizeAllowedForAudience(audience, value);
    })) {
      return Promise.reject(new Error('That size is not available for this wardrobe.'));
    }

    var previousCurrent = clean(current);
    if (hasPreferences(current) && current.audience !== audience) {
      current = wardrobeForAudience(audience);
    } else if (!hasPreferences(current)) {
      current.audience = audience;
    }
    var previous = clean(current);
    var hadPreferences = hasPreferences(previous);

    current.audience = audience;
    if (current.categories.indexOf(categoryKey) === -1) {
      if (current.categories.length >= 30) {
        return Promise.reject(new Error('This wardrobe already has the maximum number of collections.'));
      }
      current.categories.push(categoryKey);
    }

    // A contextual "usual size" answer is a garment-family default, not a
    // permission to hide every other collection. Apply it to compatible Tops,
    // Bottoms or Dresses; the Advanced editor can still replace it with a
    // collection-specific `custom` size or deliberately choose `all`.
    current.sizes[sizeType] = sizeValues.slice(0, 8);
    var existing = current.categoryPreferences[categoryKey] || {};
    current.categoryPreferences[categoryKey] = {
      sizeMode: 'default',
      sizes: [],
      styles: Array.isArray(existing.styles) ? existing.styles.slice(0, 24) : [],
      patterns: Array.isArray(existing.patterns) ? existing.patterns.slice(0, 16) : [],
      brands: Array.isArray(existing.brands) ? existing.brands.slice(0, 24) : []
    };
    current = clean(current);

    return saveCurrent({ activate: options.activate === true }).then(function (wardrobe) {
      emit('wardrobe_size_changed', {
        audience: wardrobe.audience,
        category: categoryKey,
        sizeType: sizeType,
        selectedCount: sizeValues.length,
        inheritedSizeFamily: true,
        source: String(options.source || 'contextual_prompt'),
        persistent: !!config.loggedIn
      });
      if (!config.loggedIn) {
        emit(hadPreferences ? 'guest_profile_saved' : 'guest_profile_created', {
          audience: wardrobe.audience,
          category: categoryKey,
          preference: 'size'
        });
      }
      return wardrobe;
    }).catch(function (error) {
      current = previousCurrent;
      notify();
      throw error;
    });
  }

  function setCategorySize(categoryKey, sizeValue, sizeType, audience, options) {
    return setCategorySizes(categoryKey, [sizeValue], sizeType, audience, options);
  }

  function setCategoryColours(categoryKey, colourValues, audience, options) {
    options = options || {};
    categoryKey = String(categoryKey || '').toLowerCase()
      .replace(/[^a-z0-9_-]/g, '').slice(0, 160);
    colourValues = (Array.isArray(colourValues) ? colourValues : [colourValues])
      .map(canonicalColour).filter(function (value, index, values) {
        return value && values.indexOf(value) === index;
      }).slice(0, WARDROBE_COLOURS.length);
    audience = String(audience || '').toLowerCase();

    if (!categoryKey) return Promise.reject(new Error('A collection is required.'));
    if (AUDIENCE_ORDER.indexOf(audience) === -1) {
      return Promise.reject(new Error('This collection does not have a supported audience.'));
    }

    var previousCurrent = clean(current);
    if (hasPreferences(current) && current.audience !== audience) {
      current = wardrobeForAudience(audience);
    } else if (!hasPreferences(current)) {
      current.audience = audience;
    }
    current.audience = audience;
    if (current.categories.indexOf(categoryKey) === -1) {
      if (current.categories.length >= 30) {
        current = previousCurrent;
        return Promise.reject(new Error('This wardrobe already has the maximum number of collections.'));
      }
      current.categories.push(categoryKey);
    }
    if (colourValues.length && colourValues.length < WARDROBE_COLOURS.length) {
      current.colours[categoryKey] = colourValues;
    } else {
      delete current.colours[categoryKey];
    }
    current = clean(current);

    return saveCurrent({ activate: options.activate === true }).then(function (wardrobe) {
      emit('wardrobe_colour_changed', {
        audience: wardrobe.audience,
        category: categoryKey,
        selectedCount: colourValues.length,
        source: String(options.source || 'contextual_prompt'),
        persistent: !!config.loggedIn
      });
      return wardrobe;
    }).catch(function (error) {
      current = previousCurrent;
      notify();
      throw error;
    });
  }

  function setCategoryPatterns(categoryKey, patternValues, audience, options) {
    options = options || {};
    categoryKey = String(categoryKey || '').toLowerCase()
      .replace(/[^a-z0-9_-]/g, '').slice(0, 160);
    patternValues = (Array.isArray(patternValues) ? patternValues : [patternValues])
      .map(function (value) {
        return String(value || '').replace(/\s+/g, ' ').trim().slice(0, 100);
      }).filter(function (value, index, values) {
        return value && values.indexOf(value) === index;
      }).slice(0, 16);
    audience = String(audience || '').toLowerCase();

    if (!categoryKey) return Promise.reject(new Error('A collection is required.'));
    if (AUDIENCE_ORDER.indexOf(audience) === -1) {
      return Promise.reject(new Error('This collection does not have a supported audience.'));
    }

    var previousCurrent = clean(current);
    if (hasPreferences(current) && current.audience !== audience) {
      current = wardrobeForAudience(audience);
    } else if (!hasPreferences(current)) {
      current.audience = audience;
    }
    current.audience = audience;
    if (current.categories.indexOf(categoryKey) === -1) {
      if (current.categories.length >= 30) {
        current = previousCurrent;
        return Promise.reject(new Error('This wardrobe already has the maximum number of collections.'));
      }
      current.categories.push(categoryKey);
    }
    var existing = current.categoryPreferences[categoryKey] || {};
    current.categoryPreferences[categoryKey] = {
      sizeMode: ['default', 'custom', 'all'].indexOf(existing.sizeMode) !== -1
        ? existing.sizeMode : 'default',
      sizes: Array.isArray(existing.sizes) ? existing.sizes.slice(0, 16) : [],
      styles: Array.isArray(existing.styles) ? existing.styles.slice(0, 24) : [],
      patterns: patternValues,
      brands: Array.isArray(existing.brands) ? existing.brands.slice(0, 24) : []
    };
    current = clean(current);

    return saveCurrent({ activate: options.activate === true }).then(function (wardrobe) {
      emit('wardrobe_pattern_changed', {
        audience: wardrobe.audience,
        category: categoryKey,
        selectedCount: patternValues.length,
        source: String(options.source || 'contextual_prompt'),
        persistent: !!config.loggedIn
      });
      return wardrobe;
    }).catch(function (error) {
      current = previousCurrent;
      notify();
      throw error;
    });
  }

  function setCategoryStyles(categoryKey, styleValues, audience, options) {
    options = options || {};
    categoryKey = String(categoryKey || '').toLowerCase()
      .replace(/[^a-z0-9_-]/g, '').slice(0, 160);
    styleValues = (Array.isArray(styleValues) ? styleValues : [styleValues])
      .map(function (value) {
        return String(value || '').replace(/\s+/g, ' ').trim().slice(0, 100);
      }).filter(function (value, index, values) {
        return value && values.indexOf(value) === index;
      }).slice(0, 24);
    audience = String(audience || '').toLowerCase();

    if (!categoryKey) return Promise.reject(new Error('A collection is required.'));
    if (AUDIENCE_ORDER.indexOf(audience) === -1) {
      return Promise.reject(new Error('This collection does not have a supported audience.'));
    }

    var previousCurrent = clean(current);
    if (hasPreferences(current) && current.audience !== audience) {
      current = wardrobeForAudience(audience);
    } else if (!hasPreferences(current)) {
      current.audience = audience;
    }
    current.audience = audience;
    if (current.categories.indexOf(categoryKey) === -1) {
      if (current.categories.length >= 30) {
        current = previousCurrent;
        return Promise.reject(new Error('This wardrobe already has the maximum number of collections.'));
      }
      current.categories.push(categoryKey);
    }
    var existing = current.categoryPreferences[categoryKey] || {};
    current.categoryPreferences[categoryKey] = {
      sizeMode: ['default', 'custom', 'all'].indexOf(existing.sizeMode) !== -1
        ? existing.sizeMode : 'default',
      sizes: Array.isArray(existing.sizes) ? existing.sizes.slice(0, 16) : [],
      styles: styleValues,
      patterns: Array.isArray(existing.patterns) ? existing.patterns.slice(0, 16) : [],
      brands: Array.isArray(existing.brands) ? existing.brands.slice(0, 24) : []
    };
    current = clean(current);

    return saveCurrent({ activate: options.activate === true }).then(function (wardrobe) {
      emit('wardrobe_style_changed', {
        audience: wardrobe.audience,
        category: categoryKey,
        selectedCount: styleValues.length,
        source: String(options.source || 'advanced_wardrobe'),
        persistent: !!config.loggedIn
      });
      return wardrobe;
    }).catch(function (error) {
      current = previousCurrent;
      notify();
      throw error;
    });
  }

  function addCategoryBrand(categoryKey, brandValue, audience, options) {
    options = options || {};
    categoryKey = String(categoryKey || '').toLowerCase()
      .replace(/[^a-z0-9_-]/g, '').slice(0, 160);
    brandValue = String(brandValue || '').replace(/\s+/g, ' ').trim().slice(0, 100);
    audience = String(audience || '').toLowerCase();

    if (!categoryKey || !brandValue) {
      return Promise.reject(new Error('A collection and brand are required.'));
    }
    if (AUDIENCE_ORDER.indexOf(audience) === -1) {
      return Promise.reject(new Error('This product does not have a supported audience.'));
    }

    var previousCurrent = clean(current);
    if (hasPreferences(current) && current.audience !== audience) {
      current = wardrobeForAudience(audience);
    } else if (!hasPreferences(current)) {
      current.audience = audience;
    }
    if (current.categories.indexOf(categoryKey) === -1) {
      current = previousCurrent;
      return Promise.reject(new Error('Choose this collection before learning its brands.'));
    }

    var existing = current.categoryPreferences[categoryKey] || {};
    var brands = Array.isArray(existing.brands) ? existing.brands.slice(0, 24) : [];
    if (brands.some(function (value) {
      return String(value).toLowerCase() === brandValue.toLowerCase();
    })) {
      var unchanged = clean(current);
      current = previousCurrent;
      return Promise.resolve(unchanged);
    }
    brands.push(brandValue);
    current.categoryPreferences[categoryKey] = {
      sizeMode: ['default', 'custom', 'all'].indexOf(existing.sizeMode) !== -1
        ? existing.sizeMode : 'default',
      sizes: Array.isArray(existing.sizes) ? existing.sizes.slice(0, 16) : [],
      styles: Array.isArray(existing.styles) ? existing.styles.slice(0, 24) : [],
      patterns: Array.isArray(existing.patterns) ? existing.patterns.slice(0, 16) : [],
      brands: brands.slice(-24)
    };
    current = clean(current);

    return saveCurrent({ activate: options.activate === true }).then(function (wardrobe) {
      emit('wardrobe_brand_learned', {
        audience: wardrobe.audience,
        category: categoryKey,
        brand: brandValue,
        source: String(options.source || 'engaged_product_view'),
        persistent: !!config.loggedIn
      });
      return wardrobe;
    }).catch(function (error) {
      current = previousCurrent;
      notify();
      throw error;
    });
  }

  function persist() {
    announce('Saving your wardrobe…');
    return saveCurrent().then(function () {
      close();
    }).catch(function (error) {
      announce('Your wardrobe could not be saved. ' + error.message, true);
    });
  }

  function addCategory(categoryKey) {
    categoryKey = String(categoryKey || '').toLowerCase().replace(/[^a-z0-9_-]/g, '').slice(0, 160);
    if (!categoryKey) return Promise.reject(new Error('A valid collection is required.'));
    if (current.categories.indexOf(categoryKey) !== -1) return Promise.resolve(clean(current));
    if (current.categories.length >= 30) return Promise.reject(new Error('This wardrobe already has the maximum number of collections.'));

    var previous = clean(current);
    current.categories.push(categoryKey);
    current = clean(current);

    return saveCurrent().then(function (wardrobe) {
      emit('wardrobe_category_added', {
        audience: wardrobe.audience,
        category: categoryKey,
        categoryCount: wardrobe.categories.length,
        persistent: !!config.loggedIn
      });
      return wardrobe;
    }).catch(function (error) {
      current = previous;
      notify();
      throw error;
    });
  }

  function renderEditorTitle() {
    if (!root) return;
    var title = root.querySelector('[data-pw-wardrobe-title]');
    if (!title) return;
    var isExisting = !!current.id || (!config.loggedIn && hasPreferences(current));
    if (!isExisting) {
      title.textContent = 'Create a New Wardrobe';
      return;
    }
    var name = !config.loggedIn
      ? guestWardrobeName(current.audience)
      : (String(current.name || 'My Wardrobe').replace(/\s+/g, ' ').trim() || 'My Wardrobe');
    var wardrobeName = /\bwardrobe\b/i.test(name)
      ? name
      : name + (/s$/i.test(name) ? "'" : "'s") + ' Wardrobe';
    title.innerHTML = '<span class="pw-wardrobe__title-action">Edit</span> ' + escapeHtml(wardrobeName);
  }

  function renderAccount() {
    var account = root && root.querySelector('[data-pw-wardrobe-account]');
    renderEditorTitle();
    if (!account) return;
    if (!config.loggedIn) {
      var localDrafts = guestDraftList();
      if (!localDrafts.length) {
        account.hidden = true;
        account.innerHTML = '';
        return;
      }
      account.hidden = false;
      account.innerHTML = '<div class="pw-wardrobe__guest-saved"><span><strong>' +
        escapeHtml(localDrafts.map(function (draft) { return audienceLabel(draft.audience); }).join(' · ')) +
        '</strong><small>' + localDrafts.length + (localDrafts.length === 1 ? ' wardrobe draft' : ' wardrobe drafts') +
        ' saved on this device</small></span>' +
        '<button type="button" class="pw-wardrobe__account-action pw-wardrobe__account-action--delete" data-pw-delete-guest>Delete drafts</button></div>';
      account.querySelector('[data-pw-delete-guest]').addEventListener('click', function () {
        if (!window.confirm('Delete every wardrobe draft from this device? This cannot be undone.')) return;
        clearGuestWardrobe();
        announce('Your device wardrobe has been deleted.');
      });
      return;
    }
    account.hidden = false;
    var advancedUrl = String(config.advancedPageUrl || '/pages/advanced-wardrobe');
    if (current.id) advancedUrl += '?wardrobe_id=' + encodeURIComponent(current.id);
    var pendingProfiles = Array.isArray(pendingGuest) ? pendingGuest.filter(hasPreferences) : [];
    var pendingHtml = pendingProfiles.length
      ? '<div class="pw-wardrobe__merge pw-wardrobe__merge--profiles">' +
        '<strong>Save the styles you built while browsing</strong>' +
        '<p>We kept each department separate. Name every wardrobe before adding it to your account.</p>' +
        '<div class="pw-wardrobe__merge-profiles">' + pendingProfiles.map(function (draft) {
          var draftName = String(draft.name || '').trim();
          if (draftName === 'My Wardrobe') draftName = '';
          return '<label><span>' + escapeHtml(audienceLabel(draft.audience)) + '</span>' +
            '<input type="text" maxlength="100" autocomplete="off" value="' + escapeHtml(draftName) +
            '" placeholder="Name this wardrobe" data-pw-import-name="' + escapeHtml(draft.audience) + '"></label>';
        }).join('') + '</div>' +
        '<button type="button" data-pw-merge>Save these wardrobes</button>' +
        '<button type="button" data-pw-keep>Keep account wardrobes only</button></div>'
      : '';
    account.innerHTML = '<select aria-label="Choose wardrobe" data-pw-wardrobe-select>' + (!current.id ? '<option value="" selected>New wardrobe</option>' : '') + wardrobes.map(function (wardrobe) {
      return '<option value="' + wardrobe.id + '"' + (wardrobe.id === current.id ? ' selected' : '') + '>' + escapeHtml(wardrobe.name) + (wardrobe.isDefault ? ' — default' : '') + '</option>';
    }).join('') + '</select><div class="pw-wardrobe__account-actions"><button type="button" class="pw-wardrobe__account-action pw-wardrobe__account-action--new" data-pw-new>New wardrobe</button><a class="pw-wardrobe__account-action pw-wardrobe__account-action--advanced" href="' + escapeHtml(advancedUrl) + '">Advanced editor</a>' + (current.id && !current.isDefault ? '<button type="button" class="pw-wardrobe__account-action pw-wardrobe__account-action--default" data-pw-default>Set as default</button>' : '') + (current.id ? '<button type="button" class="pw-wardrobe__account-action pw-wardrobe__account-action--delete" data-pw-delete>Delete wardrobe</button>' : '') + '</div>' +
      pendingHtml;
    var select = account.querySelector('[data-pw-wardrobe-select]');
    if (select) select.addEventListener('change', function () {
      selectWardrobe(Number(this.value), false);
    });
    account.querySelector('[data-pw-new]').addEventListener('click', function () {
      current = blank();
      current.isDefault = wardrobes.length === 0;
      step = 0;
      renderAccount();
      render();
    });
    var defaultButton = account.querySelector('[data-pw-default]');
    if (defaultButton) defaultButton.addEventListener('click', function () {
      api('/' + current.id + '/default', 'POST').then(function (payload) { current = clean(payload.wardrobe); return loadRemote(); }).then(renderAccount).catch(function (error) { announce(error.message, true); });
    });
    var deleteButton = account.querySelector('[data-pw-delete]');
    if (deleteButton) deleteButton.addEventListener('click', function () {
      if (!window.confirm('Delete this wardrobe?')) return;
      api('/' + current.id, 'DELETE').then(function () { return loadRemote(); }).then(function () { step = 0; renderAccount(); render(); notify(); }).catch(function (error) { announce(error.message, true); });
    });
    var mergeButton = account.querySelector('[data-pw-merge]');
    if (mergeButton) mergeButton.addEventListener('click', function () {
      var importNames = {};
      var allNamed = true;
      account.querySelectorAll('[data-pw-import-name]').forEach(function (input) {
        var value = String(input.value || '').replace(/\s+/g, ' ').trim().slice(0, 100);
        input.classList.toggle('is-error', !value);
        if (!value) allNamed = false;
        importNames[input.getAttribute('data-pw-import-name')] = value;
      });
      if (!allNamed) {
        announce('Name each wardrobe before saving it.', true);
        return;
      }
      mergeButton.disabled = true;
      announce('Saving your wardrobes…');
      var imported = [];
      var request = Promise.resolve();
      pendingProfiles.forEach(function (profile, index) {
        request = request.then(function () {
          var guest = clean(profile);
          guest.id = null;
          guest.name = importNames[guest.audience];
          guest.isDefault = wardrobes.length === 0 && index === 0;
          return api('', 'POST', guest).then(function (payload) {
            if (payload.wardrobe) imported.push(clean(payload.wardrobe));
          });
        });
      });
      request.then(function () {
        pendingGuest = [];
        clearGuestStorage();
        emit('guest_profile_merged', {
          wardrobeCount: imported.length,
          audiences: imported.map(function (wardrobe) { return wardrobe.audience; })
        });
        return loadRemote();
      }).then(function () { renderAccount(); render(); }).catch(function (error) { announce(error.message, true); });
    });
    var keepButton = account.querySelector('[data-pw-keep]');
    if (keepButton) keepButton.addEventListener('click', function () {
      pendingGuest = [];
      clearGuestStorage();
      renderAccount();
    });
  }

  function loadRemote() {
    if (!config.loggedIn) return Promise.resolve();
    return api('', 'GET').then(function (payload) {
      pendingGuest = guestDraftList();
      wardrobes = Array.isArray(payload.wardrobes) ? payload.wardrobes.map(clean) : [];
      if (wardrobes.length) {
        var selectedId = 0;
        try { selectedId = Number(window.localStorage.getItem(SELECTED_KEY) || 0); } catch (error) {}
        var selected = wardrobes.filter(function (item) { return item.id === selectedId; })[0];
        current = clean(selected || wardrobes.filter(function (item) { return item.isDefault; })[0] || wardrobes[0]);
        rememberSelectedWardrobe(current.id);
      } else current = blank();
      notify();
    });
  }

  function open() {
    if (!root) return;
    previousFocus = document.activeElement;
    root.hidden = false;
    document.body.classList.add('pw-wardrobe-open');
    step = 0;
    renderAccount();
    render();
    root.querySelector('.pw-wardrobe__panel').focus();
    emit('wardrobe_builder_started', { audience: current.audience, persistent: !!config.loggedIn });
  }

  function openFromTrigger(event) {
    var trigger = event && event.currentTarget;
    var path = window.location && window.location.pathname
      ? String(window.location.pathname).replace(/\/$/, '') : '';
    var wardrobePath = String(config.pageUrl || '/pages/my-wardrobe').replace(/\/$/, '');
    if (trigger && trigger.hasAttribute('data-pw-wardrobe-home') && hasPreferences(current) && path !== wardrobePath) {
      window.location.href = wardrobePath;
      return;
    }
    open();
  }

  function toggleFromHeader() {
    if (!hasPreferences(current)) {
      open();
      return false;
    }
    return setActive(!active);
  }

  function selectableWardrobes() {
    var list = config.loggedIn ? wardrobes : guestDraftList();
    return list.filter(hasPreferences).map(clean);
  }

  function isCurrentWardrobe(wardrobe) {
    if (config.loggedIn) return !!wardrobe.id && wardrobe.id === current.id;
    return wardrobe.audience === current.audience;
  }

  function setHeaderWardrobeMenuOpen(control, open) {
    if (!control) return;
    var toggle = control.querySelector('[data-pw-wardrobe-toggle]');
    var menu = control.querySelector('[data-pw-header-wardrobe-menu]');
    open = !!open && selectableWardrobes().length > 1;
    control.classList.toggle('is-menu-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (menu) menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    var sectionHeader = document.getElementById
      ? document.getElementById('shopify-section-header') : null;
    if (sectionHeader) {
      sectionHeader.classList.toggle('pw-header--wardrobe-menu-open',
        !!document.querySelector('[data-pw-header-wardrobe].is-menu-open'));
    }
  }

  function closeHeaderWardrobeMenus(except) {
    document.querySelectorAll('[data-pw-header-wardrobe].is-menu-open').forEach(function (control) {
      if (control !== except) setHeaderWardrobeMenuOpen(control, false);
    });
  }

  function renderHeaderWardrobeControls() {
    var available = selectableWardrobes();
    var multiple = available.length > 1;
    var isApplied = active && hasPreferences(current);
    document.querySelectorAll('[data-pw-header-wardrobe]').forEach(function (control) {
      var toggle = control.querySelector('[data-pw-wardrobe-toggle]');
      var menu = control.querySelector('[data-pw-header-wardrobe-menu]');
      var options = control.querySelector('[data-pw-header-wardrobe-options]');
      var power = control.querySelector('[data-pw-header-wardrobe-power]');
      var chevron = control.querySelector('.pw-header-wardrobe-chevron');
      control.classList.toggle('is-multiple', multiple);
      if (chevron) chevron.hidden = !multiple;
      if (toggle) {
        if (multiple) toggle.setAttribute('aria-haspopup', 'menu');
        else toggle.removeAttribute('aria-haspopup');
        if (multiple && control.hasAttribute('data-pw-wardrobe-mobile')) {
          toggle.setAttribute('aria-label', 'Choose a Wardrobe or turn My Wardrobe ' + (isApplied ? 'off' : 'on'));
          toggle.setAttribute('title', 'Choose a Wardrobe or turn My Wardrobe ' + (isApplied ? 'off' : 'on'));
        } else if (multiple) {
          toggle.setAttribute('title', (isApplied ? 'Click to turn My Wardrobe off' : 'Click to turn My Wardrobe on') + '; hover to choose another Wardrobe');
        }
      }
      if (!menu) return;
      menu.hidden = !multiple;
      menu.setAttribute('role', 'menu');
      if (!multiple) {
        setHeaderWardrobeMenuOpen(control, false);
        if (options) options.innerHTML = '';
        return;
      }
      if (options) {
        options.innerHTML = available.map(function (wardrobe) {
          var selected = isCurrentWardrobe(wardrobe);
          var detail = audienceLabel(wardrobe.audience);
          if (config.loggedIn && wardrobe.isDefault) detail += ' · Default';
          var identity = config.loggedIn
            ? ' data-pw-wardrobe-id="' + wardrobe.id + '"'
            : ' data-pw-wardrobe-audience="' + escapeHtml(wardrobe.audience) + '"';
          return '<button type="button" class="pw-header-wardrobe-option' + (selected ? ' is-selected' : '') +
            '" role="menuitemradio" aria-checked="' + (selected ? 'true' : 'false') +
            '" data-pw-header-wardrobe-choice' + identity + '><span><strong>' +
            escapeHtml(wardrobe.name || guestWardrobeName(wardrobe.audience)) + '</strong><small>' +
            escapeHtml(detail) + '</small></span><span class="pw-header-wardrobe-option__check" aria-hidden="true">' +
            (selected ? '✓' : '') + '</span></button>';
        }).join('');
      }
      if (power) {
        power.textContent = 'Turn My Wardrobe ' + (isApplied ? 'off' : 'on');
        power.setAttribute('aria-pressed', isApplied ? 'true' : 'false');
      }
      setHeaderWardrobeMenuOpen(control, control.classList.contains('is-menu-open'));
    });
  }

  function chooseHeaderWardrobe(button) {
    var control = button.closest('[data-pw-header-wardrobe]');
    var toggle = control && control.querySelector('[data-pw-wardrobe-toggle]');
    var selected = null;
    if (button.hasAttribute('data-pw-wardrobe-id')) {
      selected = selectWardrobe(Number(button.getAttribute('data-pw-wardrobe-id')), true);
    } else if (button.hasAttribute('data-pw-wardrobe-audience')) {
      selected = selectGuestWardrobe(button.getAttribute('data-pw-wardrobe-audience'), true);
    }
    setHeaderWardrobeMenuOpen(control, false);
    if (toggle && toggle.focus) toggle.focus();
    return selected;
  }

  function handleWardrobeToggleClick(event) {
    var target = event && event.target;
    var choice = target && target.closest
      ? target.closest('[data-pw-header-wardrobe-choice]')
      : null;
    if (choice) {
      if (event.preventDefault) event.preventDefault();
      chooseHeaderWardrobe(choice);
      return;
    }
    var power = target && target.closest
      ? target.closest('[data-pw-header-wardrobe-power]')
      : null;
    if (power) {
      if (event.preventDefault) event.preventDefault();
      toggleFromHeader();
      setHeaderWardrobeMenuOpen(power.closest('[data-pw-header-wardrobe]'), false);
      return;
    }
    var button = target && target.closest
      ? target.closest('[data-pw-wardrobe-toggle]')
      : null;
    if (button) {
      if (event.preventDefault) event.preventDefault();
      var control = button.closest ? button.closest('[data-pw-header-wardrobe]') : null;
      if (control && control.hasAttribute('data-pw-wardrobe-mobile') && selectableWardrobes().length > 1) {
        renderHeaderWardrobeControls();
        setHeaderWardrobeMenuOpen(control, !control.classList.contains('is-menu-open'));
        return;
      }
      toggleFromHeader();
      return;
    }
    if (!target || !target.closest || !target.closest('[data-pw-header-wardrobe]')) closeHeaderWardrobeMenus();
  }

  function handleHeaderWardrobeMouseOver(event) {
    var control = event.target && event.target.closest
      ? event.target.closest('[data-pw-wardrobe-desktop]') : null;
    if (!control || (event.relatedTarget && control.contains(event.relatedTarget))) return;
    renderHeaderWardrobeControls();
    if (selectableWardrobes().length > 1) setHeaderWardrobeMenuOpen(control, true);
  }

  function handleHeaderWardrobeMouseOut(event) {
    var control = event.target && event.target.closest
      ? event.target.closest('[data-pw-wardrobe-desktop]') : null;
    if (!control || (event.relatedTarget && control.contains(event.relatedTarget))) return;
    setHeaderWardrobeMenuOpen(control, false);
  }

  function handleHeaderWardrobeFocusIn(event) {
    var control = event.target && event.target.closest
      ? event.target.closest('[data-pw-wardrobe-desktop]') : null;
    if (!control) return;
    // A pointer click focuses its option before the browser emits `click`.
    // Rebuilding the option list here would detach that button and cancel the
    // pending click, so an already-open chooser must keep its current DOM.
    if (control.classList.contains('is-menu-open') ||
        (event.relatedTarget && control.contains(event.relatedTarget))) return;
    renderHeaderWardrobeControls();
    if (selectableWardrobes().length > 1) setHeaderWardrobeMenuOpen(control, true);
  }

  function handleHeaderWardrobeFocusOut(event) {
    var control = event.target && event.target.closest
      ? event.target.closest('[data-pw-wardrobe-desktop]') : null;
    if (!control || (event.relatedTarget && control.contains(event.relatedTarget))) return;
    setHeaderWardrobeMenuOpen(control, false);
  }

  function handleHeaderWardrobeKeydown(event) {
    if (event.key !== 'Escape') return;
    var control = event.target && event.target.closest
      ? event.target.closest('[data-pw-header-wardrobe]') : null;
    if (!control || !control.classList.contains('is-menu-open')) return;
    setHeaderWardrobeMenuOpen(control, false);
    var toggle = control.querySelector('[data-pw-wardrobe-toggle]');
    if (toggle && toggle.focus) toggle.focus();
  }

  function close() {
    if (!root) return;
    root.hidden = true;
    document.body.classList.remove('pw-wardrobe-open');
    if (previousFocus && previousFocus.focus) previousFocus.focus();
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  function init() {
    root = document.getElementById('PrewornWardrobe');
    if (!root) { resolveReady(); return; }
    body = root.querySelector('[data-pw-wardrobe-body]');
    status = root.querySelector('[data-pw-wardrobe-status]');
    document.querySelectorAll('[data-pw-wardrobe-open]').forEach(function (button) { button.addEventListener('click', openFromTrigger); });
    root.querySelectorAll('[data-pw-wardrobe-close]').forEach(function (button) { button.addEventListener('click', close); });
    root.querySelector('[data-pw-wardrobe-back]').addEventListener('click', function () { if (step > 0) { step -= 1; render(); } });
    root.querySelector('[data-pw-wardrobe-next]').addEventListener('click', function () {
      if (step === 1 && !current.categories.length) { announce('Choose at least one clothing category.', true); return; }
      if (step < 5) { step += 1; render(); } else persist();
    });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !root.hidden) close(); });
    loadRemote().then(function () {
      renderAccount(); notify();
    }).catch(function () {
      readyError = true;
      announce('Account sync is temporarily unavailable. Your local wardrobe is still available.', true); notify();
    }).then(resolveReady);
    notify();
  }

  // The Shopify header can be replaced after initialisation. Delegate the
  // click so newly rendered desktop and mobile controls keep working.
  document.addEventListener('click', handleWardrobeToggleClick);
  document.addEventListener('mouseover', handleHeaderWardrobeMouseOver);
  document.addEventListener('mouseout', handleHeaderWardrobeMouseOut);
  document.addEventListener('focusin', handleHeaderWardrobeFocusIn);
  document.addEventListener('focusout', handleHeaderWardrobeFocusOut);
  document.addEventListener('keydown', handleHeaderWardrobeKeydown);

  window.PrewornWardrobe = {
    open: open,
    close: close,
    getWardrobe: function () { return clean(current); },
    getWardrobeForAudience: wardrobeForAudience,
    getGuestDrafts: function () { return guestDraftList(); },
    ready: function () { return readyPromise; },
    isActive: function () { return active && hasPreferences(current); },
    setActive: setActive,
    toggle: toggleFromHeader,
    addCategory: addCategory,
    setCategorySize: setCategorySize,
    setCategorySizes: setCategorySizes,
    setCategoryColours: setCategoryColours,
    setCategoryStyles: setCategoryStyles,
    setCategoryPatterns: setCategoryPatterns,
    addCategoryBrand: addCategoryBrand,
    getWardrobes: function () { return config.loggedIn ? wardrobes.map(clean) : guestDraftList(); },
    getCategoryLabels: function () {
      return loadOptions(current.audience, current.sizes).then(categoryLabelMap);
    },
    getCategoryOptions: function (audience) {
      audience = AUDIENCE_ORDER.indexOf(audience) !== -1
        ? audience : current.audience;
      var selectedSizes = audience === current.audience ? current.sizes : {};
      return loadOptions(audience, selectedSizes).then(categoryOptions);
    },
    getColourOptions: function () {
      return loadOptions(current.audience, current.sizes).then(colourOptions);
    },
    getCategorySizeOptions: function (categoryKey, audience) {
      audience = AUDIENCE_ORDER.indexOf(audience) !== -1
        ? audience : current.audience;
      var selectedSizes = audience === current.audience ? current.sizes : {};
      return loadOptions(audience, selectedSizes).then(function (payload) {
        return categorySizeOptions(payload, audience, categoryKey);
      });
    },
    sizeAllowedForAudience: sizeAllowedForAudience,
    selectWardrobe: selectWardrobe,
    selectGuestWardrobe: selectGuestWardrobe,
    createWardrobe: createWardrobe,
    deleteGuestWardrobe: clearGuestWardrobe,
    refresh: function () {
      return loadRemote().then(function () { renderAccount(); notify(); return clean(current); });
    },
    getScopeParams: scopeParams,
    getFilterParams: filterParams
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
